import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyObject, ErrorMessage } from '@mri/types';

@Component({
  selector: 'app-field-text',
  templateUrl: './field-text.component.html',
  styleUrl: './field-text.component.scss'
})
export class FieldTextComponent {

  private _classSet: Set<string> = new Set<string>();

  @Output() valueChange = new EventEmitter<string>;
  @Input() placeholder?: string;
  @Input() value?: string;
  @Input() label: string;
  @Input() errors?: Array<ErrorMessage>;
  @Input() image?: string | ((value: string) => string);

  get classes(): string {
    return [...this._classSet].join(' ');
  }

  onChange(event: AnyObject){
    this.valueChange.emit(event.target.value)
  }

  onFocus(){
    this._classSet.add('card-focus');
  }

  onBlur(){
    this._classSet.delete('card-focus');
  }
}
